import React, { useEffect, useRef, useState } from 'react';

const VIDEO_ID = 'bKkXO8078V0';

// Vidéo de fond : n'apparaît que si YouTube la joue vraiment, sinon la photo reste seule.
export const HeroVideo = () => {
  const holder = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let player;
    const build = () => {
      if (!holder.current || !window.YT?.Player) return;
      player = new window.YT.Player(holder.current, {
        videoId: VIDEO_ID,
        playerVars: {
          autoplay: 1, mute: 1, loop: 1, playlist: VIDEO_ID, controls: 0,
          modestbranding: 1, disablekb: 1, fs: 0, iv_load_policy: 3, rel: 0, playsinline: 1,
        },
        events: {
          onReady: (e) => e.target.playVideo(),
          onStateChange: (e) => { if (e.data === window.YT.PlayerState.PLAYING) setPlaying(true); },
          onError: () => setFailed(true),
        },
      });
    };

    if (window.YT?.Player) {
      build();
    } else {
      const prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => { prev?.(); build(); };
      if (!document.querySelector('script[src*="iframe_api"]')) {
        const s = document.createElement('script');
        s.src = 'https://www.youtube.com/iframe_api';
        document.body.appendChild(s);
      }
    }

    const guard = setTimeout(() => setFailed((f) => f || !player), 9000);
    return () => { clearTimeout(guard); player?.destroy?.(); };
  }, []);

  if (failed) return null;

  return (
    <div
      className="absolute top-1/2 left-1/2 pointer-events-none transition-opacity duration-1000"
      style={{
        width: '284vh', height: '160vh',
        minWidth: '178%', minHeight: '100vw',
        transform: 'translate(-50%, -50%)',
        opacity: playing ? 1 : 0,
      }}
      data-testid="hero-video"
    >
      <div ref={holder} className="w-full h-full" />
    </div>
  );
};

export default HeroVideo;
